import { Button, Checkbox } from '@yellowcard/components-library-vue3';
import { defineComponent, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { usePaymentStore } from '@/store/modules/payment';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import { usePayoutAccountsStore } from '@/store/modules/payout-accounts';
import useTransactionsStore from '@/store/modules/transactions';
import router, { RoutePaths } from '@/router';
import LoaderComponent from '../general/LoaderComponent.vue';
export default defineComponent({
    name: 'SavePayoutAccountPrompt',
    props: {},
    components: {
        Button,
        TransactHeader,
        Checkbox,
        LoaderComponent,
    },
    setup() {
        const paymentsStore = usePaymentStore();
        const { sellPaymentAccountName, sellPaymentAccountNumber, selectedPaymentNetwork, } = storeToRefs(paymentsStore);
        const termsAccepted = ref(false);
        const payoutAccountsStore = usePayoutAccountsStore();
        const { loading: payoutLoading, activePayoutAccount } = storeToRefs(payoutAccountsStore);
        const transactionsStore = useTransactionsStore();
        const { loading } = storeToRefs(transactionsStore);
        const onKeyPress = (event) => {
            event.preventDefault();
        };
        const savePayoutAccount = async () => {
            await payoutAccountsStore.addPayoutAccount();
            sellPaymentAccountName.value = activePayoutAccount.value.accountName;
            sellPaymentAccountNumber.value = activePayoutAccount.value.accountNumber;
            selectedPaymentNetwork.value = {
                id: activePayoutAccount.value.networkId,
            };
            await transactionsStore.getWalletDetails();
        };
        const backClick = () => {
            router.push(RoutePaths.PayoutAccounts);
        };
        const continueWithoutSaving = async () => {
            selectedPaymentNetwork.value = {
                id: activePayoutAccount.value.networkId,
            };
            await transactionsStore.getWalletDetails();
        };
        const termsToggled = (value) => {
            termsAccepted.value = !!value.length;
        };
        return {
            backClick,
            onKeyPress,
            termsToggled,
            savePayoutAccount,
            continueWithoutSaving,
            termsAccepted,
            loading,
            payoutLoading,
        };
    },
});
